module.exports = __webpack_public_path__ + "static/favicon-196x196-e6b5adf21adb0926af77442ff47a7017.png";